// CSS
import 'lightgallery/css/lightgallery-bundle.css';

// Core
import lightGallery from 'lightgallery';

// Plugins
import lgThumbnail from 'lightgallery/plugins/thumbnail'
import lgZoom from 'lightgallery/plugins/zoom'

const licenseKey = '901CF93A-B27A4DD2-88F39B05-C873BC34';

function initArticleListOverviewAlbumButtons() {
    let articleOverviewButtonList = document.querySelectorAll(".js-openArticleListOverviewAlbumBtn");
    articleOverviewButtonList.forEach(addClickHandler);
}

document.addEventListener('DOMContentLoaded', initArticleListOverviewAlbumButtons);

function addClickHandler(item) {
    item.addEventListener("click", function () {
        let selector = item.parentElement.id;

        let gallery = lightGallery(document.getElementById(selector), {
            plugins: [lgZoom, lgThumbnail],
            licenseKey: licenseKey,
            selector: ".item",
            allowMediaOverlap: false,
            thumbnail: true,
            exThumbImage: 'data-thumb-image',
            defaultCaptionHeight: 0,
            download: false,
            speed: 500,
            zoom: true,
            zoomFromOrigin: true,
            scale: 3,
            actualSize: false,
            showZoomInOutIcons: true,
            closable: true,
            counter: true,
            mobileSettings: {
                controls: true,
                showCloseIcon: true,
                download: false,
                zoom: true,
            }
        });
        gallery.openGallery();
    });
}
